import React, { useEffect, useState } from "react";
import { getValueWithUOM, LastUpdated, getValueWithUOMForBP } from "../../helper/MetricsUtil";
import { MetricTypeConstants, metricMaxVal, metricUOM } from "../../constants/MetricTypeConstrants";
import { useParams, useSearchParams } from "react-router-dom";

interface MatrixCardProps {
  type: keyof typeof MetricTypeConstants;
  value: number;
  predicted: number | undefined;
  trend?: 'up' | 'down';
  range?: string;
  lastUpdated?: string;
  elevatedReadings?: string;
}

export const MatrixCard: React.FC<MatrixCardProps> = ({ type, value, predicted, trend, range, lastUpdated, elevatedReadings }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('Error while fetching metric');

  const [searchParams] = useSearchParams();
  // const patientId = searchParams.get("patientId");

  const { patientId } = useParams<{ patientId: string }>();

  const PLACEHOLDER = <span className="placeholder-wave">
    <span className="placeholder w-100"></span>
  </span>;

  let actualData: any;
  let predictedData: any;
  if (MetricTypeConstants[type] !== MetricTypeConstants.ELEVATED_READINGS) {
    actualData = getValueWithUOM(MetricTypeConstants[type] as string, value);
    if (MetricTypeConstants[type] !== MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted) {
      predictedData = getValueWithUOM(MetricTypeConstants[type] as string, predicted);
    } else if (MetricTypeConstants[type] === MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted) {
      actualData = getValueWithUOMForBP(MetricTypeConstants[type] as string, value, predicted);
    }
  }

  

  return (
    <>
      {
        MetricTypeConstants[type] !== MetricTypeConstants.ELEVATED_READINGS ? <div className={`col-12 col-md-${patientId ? '4' : '2'}`}>
          <div className="border p-4 rounded-3 shadow-sm bg-white">
            {MetricTypeConstants[type] === MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted ?
              <strong className="fs-12 text-primary">Blood Pressure</strong> :
              <strong className="fs-12 text-primary">{MetricTypeConstants[type] as string}</strong>}

            {range && <div className="fs-11 text-light">{range}</div>}
            <div className={MetricTypeConstants[type] !== MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted ? 'd-flex text-center' : ''}>
              <div className={MetricTypeConstants[type] !== MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted ? 'w-50' : ''}>
                {actualData.displayHTML}
                {trend && <span className={`material-symbols-outlined text-${trend === 'up' ? 'success' : 'danger-light'} fs-18 align-text-top`}>trending_{trend}</span>}
                {MetricTypeConstants[type] !== MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted ? <div className="text-light fs-11 me-1">Actual</div> : ''}
              </div>
              {MetricTypeConstants[type] !== MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC && predicted ? <div className="w-50">
                {predictedData.displayHTML}
                <div className="text-light fs-11 me-1">Predicted</div>
              </div> : ''}
            </div>
            <LastUpdated lastUpdated={lastUpdated ?? undefined} />
          </div>
        </div> : ''
      }

      {
        MetricTypeConstants[type] === MetricTypeConstants.ELEVATED_READINGS ?
          <div className={`col-12 col-md-${patientId ? '4' : '2'}`}>
            <div className="border p-4 rounded-3 shadow-sm bg-white">
              <strong className="fs-12 text-primary">{MetricTypeConstants[type] as string}</strong>
              <div className="d-flex">
                <div className="w-40">
                  <strong className='fs-18'>{value}</strong> <span className='text-light fs-11 me-1'>readings</span>
                </div>
                <div className="w-60">
                  <strong className='fs-18'>
                    {elevatedReadings}
                  </strong> <span className='text-light fs-11 me-1'>{metricUOM.get(MetricTypeConstants.BLOOD_PRESSURE_SYSTOLIC)}</span>
                </div>
              </div>
              <div className="fs-11 text-light">Last 30 days</div>
            </div>
          </div> : ''
      }
      

      {loading && <div className="col-12 col-md-4"><div className='border p-4 rounded-3 shadow-sm mt-2 bg-white'>
        <strong className="fs-12 text-primary">{PLACEHOLDER}</strong>
        <div className='w-30'>
          <strong className='fs-12 me-1'>{PLACEHOLDER}</strong>
        </div>
        <div className='w-50'>
          <strong className='fs-20 me-1'>{PLACEHOLDER}</strong>
        </div>
        <div className="fs-11 text-light">{PLACEHOLDER}</div>
      </div></div>}

      {/* {error && !value && <div className="col-12 col-md-4"><div className='border p-4 rounded-3 shadow-sm mt-2 align-items-center'>
        <div className="alert alert-danger border-0" role="alert">
          {error}
        </div>
      </div></div>} */}
    </>
  );
};